import { useEntryCRUDActions } from '@mm/state/actions/EntryCRUDActions';
import { uploadImage } from '@mm/state/actions/uploadActions';
import { UploadImgModel } from '@mm/state/model/UploadImgModel';
import WidgetModel, { ListAndGalleryEntry } from '@mm/state/model/WidgetModel';
import { StoreState } from '@mm/state/store-interfaces';
import { get } from 'lodash';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OptinImageView from '../Components/OptinImageView';

type PropsFromDispatch = ReturnType<typeof mapDispatchToProps>;

type OuterProps = {
  widget: WidgetModel;
  onRemoteWidgetUpdated: () => void;
};
type Props = PropsFromDispatch & OuterProps;

type onRemoteWidgetUpdatedType = () => void;

const updateEntryHelper = async (
  widget: WidgetModel,
  assetId: number | null,
  updateEntry: ReturnType<typeof useEntryCRUDActions>['update'],
  onRemoteWidgetUpdated: onRemoteWidgetUpdatedType,
): Promise<void> => {
  const entry: ListAndGalleryEntry | undefined = get(
    widget,
    'config.entries[0]',
  );
  if (entry) {
    await updateEntry(widget.id, { ...entry, assetId });
  }
  onRemoteWidgetUpdated();
};

const OptinGallery = ({
  uploadImage,
  widget,
  onRemoteWidgetUpdated,
}: Props) => {
  const imageUrl: string | null = get(widget, 'config.entries[0].file', null);

  const { update: updateEntry } = useEntryCRUDActions();

  const memoizedUploadImage = useCallback(
    async (img64: UploadImgModel) => {
      const assetId = await uploadImage(img64);
      await updateEntryHelper(
        widget,
        assetId,
        updateEntry,
        onRemoteWidgetUpdated,
      );
    },
    [widget, onRemoteWidgetUpdated],
  );

  const memoizedRemoveImage = useCallback(async () => {
    await updateEntryHelper(widget, null, updateEntry, onRemoteWidgetUpdated);
  }, [widget, onRemoteWidgetUpdated]);

  return (
    <OptinImageView
      uploadImage={memoizedUploadImage}
      imageUrl={imageUrl}
      removeImage={memoizedRemoveImage}
    />
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  uploadImage: (img64: UploadImgModel): Promise<number> =>
    dispatch(uploadImage(img64)),
});

export default connect<{}, PropsFromDispatch, OuterProps>(
  null,
  mapDispatchToProps,
)(OptinGallery);
